import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    add: 'Add a client',
    title: 'Clients',
  },
  fr: {
    add: 'Ajouter un·e client·e',
    title: 'Client·es',
  },
} as const);

export default locales;
